import React from "react";
import { APP_VERSION } from "../../helpers/version";

/**
 * 側欄左下角的版號(取代模板原本的 © Borex 版權列)。
 * 號碼與遞增規則見 helpers/version.js;樣式 `.dck-version` 在 _dck-figma.scss。
 */
const Footer = () => (
  <div className="sidebar-footer dck-version" data-testid="app-version">
    {APP_VERSION}
  </div>
);

export default Footer;
